import { default as HeaderH1 } from './HeaderH1';

const EXPORT = { HeaderH1 };

export default EXPORT;
